<section
  (click)="onCollectionClicked()"
  [ngClass]="{
    small: displayType === DisplayType.SMALL,
    big: displayType === DisplayType.BIG,
  }"
  class="collection-container"
>
  <div class="left-part">
    <collection-icon
      [displayType]="displayType"
      [icons]="collectionFinderData.icons"
    />
  </div>

  <div class="right-part">
    <div class="label">
      <div [tooltip]="collectionFinderData.title!">
        <a
          #titleElement
          class="title line-clamp-2"
          [ngClass]="{
            '!cursor-default':
              clickOnAppBehavior === ClickOnAppBehavior.NO_BEHAVIOR,
          }"
          class="title line-clamp-2"
        >
          {{ collectionFinderData.title }}
        </a>
        <a
          class="subtitle line-clamp-1"
          [ngClass]="{
            '!cursor-default':
              clickOnAppBehavior === ClickOnAppBehavior.NO_BEHAVIOR,
          }"
          class="subtitle line-clamp-1"
        >
          {{ collectionFinderData.subtitle }}
        </a>
      </div>
    </div>
    @if (collectionFinderData && collectionFinderData.isAdded !== undefined) {
      <div class="add-remove-button">
        <add-remove-button-collection [collection]="collectionFinderData" (click)="stopPropagation($event)"/>
      </div>
    }
  </div>
</section>
